/**
 * Ciudades principales por país (top 10-15 por habitantes / volumen comercial).
 * Se usa para dropdown obligatorio. Si seleccionan "Otro" país, la ciudad
 * se vuelve texto libre.
 */

export const COUNTRIES = [
  "Colombia", "Argentina", "Brasil", "México", "Uruguay", "Chile", "Ecuador",
  "Perú", "Venezuela", "Paraguay", "Bolivia", "Costa Rica", "Panamá",
  "Estados Unidos", "España", "Otro",
] as const;

export const CITIES_BY_COUNTRY: Record<string, string[]> = {
  "Colombia": [
    "Bogotá", "Medellín", "Cali", "Barranquilla", "Cartagena", "Cúcuta",
    "Bucaramanga", "Pereira", "Santa Marta", "Ibagué", "Manizales",
    "Pasto", "Neiva", "Villavicencio", "Armenia", "Sincelejo", "Popayán",
    "Valledupar", "Montería", "Tunja", "Riohacha", "Quibdó", "Florencia",
  ],
  "Argentina": [
    "Buenos Aires", "Córdoba", "Rosario", "Mendoza", "La Plata",
    "Mar del Plata", "San Miguel de Tucumán", "Salta", "Santa Fe",
    "San Juan", "Resistencia", "Neuquén", "Posadas", "Corrientes",
    "Bahía Blanca", "Paraná", "San Salvador de Jujuy", "Río Cuarto",
  ],
  "Brasil": [
    "São Paulo", "Río de Janeiro", "Brasilia", "Salvador", "Fortaleza",
    "Belo Horizonte", "Manaos", "Curitiba", "Recife", "Porto Alegre",
    "Belém", "Goiânia", "Guarulhos", "Campinas", "São Luís", "Maceió",
  ],
  "México": [
    "Ciudad de México", "Guadalajara", "Monterrey", "Puebla", "Toluca",
    "Tijuana", "León", "Ciudad Juárez", "Mérida", "Querétaro",
    "Cancún", "Aguascalientes", "Mexicali", "Saltillo", "Hermosillo",
    "Culiacán", "Morelia", "Acapulco", "Veracruz", "Chihuahua",
  ],
  "Uruguay": [
    "Montevideo", "Salto", "Ciudad de la Costa", "Paysandú",
    "Las Piedras", "Rivera", "Maldonado", "Tacuarembó", "Melo", "Mercedes",
  ],
  "Chile": [
    "Santiago", "Valparaíso", "Concepción", "La Serena", "Antofagasta",
    "Temuco", "Rancagua", "Iquique", "Talca", "Arica",
    "Puerto Montt", "Chillán", "Calama", "Osorno", "Viña del Mar",
  ],
  "Ecuador": [
    "Quito", "Guayaquil", "Cuenca", "Santo Domingo", "Machala",
    "Manta", "Portoviejo", "Loja", "Ambato", "Esmeraldas",
    "Riobamba", "Latacunga", "Ibarra",
  ],
  "Perú": [
    "Lima", "Arequipa", "Trujillo", "Chiclayo", "Iquitos", "Piura",
    "Cusco", "Tacna", "Chimbote", "Huancayo", "Pucallpa", "Ayacucho",
    "Juliaca", "Sullana", "Ica",
  ],
  "Venezuela": [
    "Caracas", "Maracaibo", "Valencia", "Barquisimeto", "Maracay",
    "Ciudad Guayana", "San Cristóbal", "Maturín", "Barcelona", "Mérida",
    "Cumaná", "Puerto La Cruz", "Petare",
  ],
  "Paraguay": [
    "Asunción", "Ciudad del Este", "Encarnación", "Pedro Juan Caballero",
    "Luque", "San Lorenzo", "Capiatá", "Lambaré",
  ],
  "Bolivia": [
    "La Paz", "Santa Cruz de la Sierra", "Cochabamba", "Sucre",
    "Oruro", "Potosí", "Tarija", "El Alto", "Trinidad",
  ],
  "Costa Rica": [
    "San José", "Limón", "Alajuela", "Cartago", "Heredia",
    "Liberia", "Puntarenas", "San Carlos", "Pérez Zeledón",
  ],
  "Panamá": [
    "Panamá", "San Miguelito", "Tocumen", "David", "Colón",
    "Las Cumbres", "La Chorrera", "Santiago de Veraguas",
  ],
  "Estados Unidos": [
    "Miami", "Nueva York", "Los Ángeles", "Houston", "Chicago",
    "Phoenix", "Atlanta", "Orlando", "Tampa", "Dallas",
    "San Francisco", "Boston", "Seattle", "Denver", "Las Vegas",
    "Washington DC", "Filadelfia", "San Diego",
  ],
  "España": [
    "Madrid", "Barcelona", "Valencia", "Sevilla", "Bilbao",
    "Málaga", "Zaragoza", "Murcia", "Palma de Mallorca", "Las Palmas",
    "Valladolid", "Vigo", "Gijón", "Alicante", "Córdoba",
  ],
};

/** Devuelve la lista de ciudades del país, o null si país es "Otro" o no listado. */
export function getCitiesFor(country: string): string[] | null {
  return CITIES_BY_COUNTRY[country] ?? null;
}
